var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLessonsBkg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FOND",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1383.939,
    height: 1037.954,
    viewBox: "0 0 1383.939 1037.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-lessons-bkg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FOND_FIXE-lessons-bkg",
    "data-name": "FOND FIXE",
    d: "M0,0H1383.939V1037.954H0Z",
    fill: "#9870b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-lessons-bkg",
    x1: 0.492,
    y1: -0.124,
    x2: 0.519,
    y2: 0.884,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dce7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#b8dcd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbe298"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-lessons-bkg-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeaa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbe298"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-lessons-bkg-3",
    x1: 0.424,
    y1: 0.676,
    x2: 0.697,
    y2: 0.003,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-lessons-bkg-4",
    x1: 0.5,
    x2: 0.5,
    y2: 0.84,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcdc96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbc39b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-lessons-bkg-5",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8c899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5d382"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "FOND_FIXE-lessons-bkg-2",
    "data-name": "FOND FIXE",
    d: "M0,0H1383.939V1037.954H0Z",
    transform: "translate(0 0)",
    fill: "#9870b6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_55",
    "data-name": "Mask Group 55",
    clipPath: "url(#clip-path-lessons-bkg)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FOND-2",
    "data-name": "FOND",
    d: "M1383.939,1037.954H0V0H1383.939Z",
    fill: "url(#linear-gradient-lessons-bkg)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "FOND_DUNE",
    "data-name": "FOND DUNE",
    transform: "translate(-47.415 829.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5336",
    "data-name": "Group 5336",
    transform: "translate(549.213 8.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8993",
    "data-name": "Path 8993",
    d: "M1182.57,344.62V479.128S153.83,424.171,298.076,403.006c279.964-41.09,445.479-106.07,579.955-107.177,26.479-.23,51.754,2.032,76.472,7.433C1139.248,343.658,1182.57,344.62,1182.57,344.62Z",
    transform: "translate(-284.211 -295.813)",
    fill: "url(#linear-gradient-lessons-bkg-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8994",
    "data-name": "Path 8994",
    d: "M896.639,344.62v30.641c-30.336,2.189-33.717,2.748-92.7-.231-167.333-8.443-204.828-64.505-211.837-79.2,26.479-.23,51.754,2.032,76.472,7.433C853.317,343.658,896.639,344.62,896.639,344.62Z",
    transform: "translate(1.721 -295.813)",
    fill: "url(#linear-gradient-lessons-bkg-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5338",
    "data-name": "Group 5338",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5337",
    "data-name": "Group 5337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8995",
    "data-name": "Path 8995",
    d: "M1447.572,413.518V555.562H0V330.675s64.336-25.2,108.94-39.61c3.115-1.007,7.251-2.764,11.235-2.605,79.175,3.15,266.9,108.183,715.842,139.151,200.157,13.8,451.044,7.818,451.044,7.818Z",
    transform: "translate(0 -288.465)",
    fill: "url(#linear-gradient-lessons-bkg-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8996",
    "data-name": "Path 8996",
    d: "M1230.073,437.5c-91.607,12.139-561.2,67.337-871.727,10.17C42.372,389.487,58.113,304.7,63.07,290.7c79.188,3.15,267.072,105.881,716.093,136.849C979.354,441.351,1124.574,439.362,1230.073,437.5Z",
    transform: "translate(56.894 -290.701)",
    fill: "url(#linear-gradient-lessons-bkg-5)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonsBkg);
export default __webpack_public_path__ + "static/media/lessons-bkg.8ab31d82.svg";
export { ForwardRef as ReactComponent };